import React, { Component } from "react";
import PropTypes from "prop-types";

import { Mutation } from "react-apollo";

import Section from "../Section";
import { EditFormButtonGroup } from "../inputs";

import {
  UPDATE_DIRECTION_MUTATION,
  DELETE_DIRECTION_MUTATION
} from "../../graphql/Directions/Directions.graphql";
import { ourToast as toast } from "../../utils";

import DirectionForm from "./DirectionForm";
import PrintDirectionButton from "./PrintDirectionButton";

class EditDirectionForm extends Component {
  state = {
    OriginLocationRecIdRef: "",
    DestinationLocationRecIdRef: "",
    LoadedMiles: "",
    LoadedTravelTime: "",
    EmptyMiles: "",
    EmptyTravelTime: "",
    LoadingTime: "",
    UnloadingTime: "",
    Directions: "",
    Priority: "1",
    SpecInstr: "",
    ...this.props.direction
  };

  onChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;

    this.setState({ [e.target.name]: value });
  };

  render() {
    const {
      OriginLocationRecIdRef,
      DestinationLocationRecIdRef,
      LoadedMiles,
      LoadedTravelTime,
      EmptyMiles,
      EmptyTravelTime,
      LoadingTime,
      UnloadingTime,
      Directions,
      Priority,
      SpecInstr
    } = this.state;

    const { setModalOpen, RecId } = this.props;
    return (
      <Mutation
        mutation={UPDATE_DIRECTION_MUTATION}
        variables={{
          data: {
            CompanyId: "TRN",
            OriginLocationRecIdRef: parseInt(OriginLocationRecIdRef),
            DestinationLocationRecIdRef: parseInt(DestinationLocationRecIdRef),
            LoadedMiles: parseFloat(LoadedMiles),
            LoadedTravelTime: parseFloat(LoadedTravelTime),
            EmptyMiles: parseFloat(EmptyMiles),
            EmptyTravelTime: parseFloat(EmptyTravelTime),
            LoadingTime: parseFloat(LoadingTime),
            UnloadingTime: parseFloat(UnloadingTime),
            Directions,
            SpecInstr,
            Priority: parseInt(Priority)
          },
          where: {
            RecId: parseInt(RecId)
          }
        }}
      >
        {(createDirection, { loading, error }) => (
          <form
            id="edit-direction"
            method="POST"
            onSubmit={async e => {
              e.preventDefault();
              try {
                await createDirection();
                setModalOpen(false);
                toast.success("Direction updated successfully.");
              } catch (err) {
                toast.error("Error updating Direction.");
              }
            }}
          >
            <fieldset aria-busy={loading}>
              <Section
                links={[
                  {
                    content: <PrintDirectionButton RecId={parseInt(RecId)} />
                  }
                ]}
                title="Edit Direction"
              >
                <DirectionForm
                  inputs={{
                    OriginLocationRecIdRef,
                    DestinationLocationRecIdRef,
                    LoadedMiles,
                    LoadedTravelTime,
                    EmptyMiles,
                    EmptyTravelTime,
                    LoadingTime,
                    UnloadingTime,
                    Directions,
                    Priority,
                    SpecInstr
                  }}
                  onChange={this.onChange}
                />
                <EditFormButtonGroup
                  confirmModalMessage="Are you sure you want to delete this direction?"
                  deleteMutation={DELETE_DIRECTION_MUTATION}
                  form="edit-direction"
                  refetchQueries={["ALL_DIRECTIONS_QUERY"]}
                  variables={{ where: { RecId: this.props.direction.RecId } }}
                  onComplete={setModalOpen}
                />
              </Section>
            </fieldset>
          </form>
        )}
      </Mutation>
    );
  }
}

EditDirectionForm.propTypes = {
  setModalOpen: PropTypes.func,
  direction: PropTypes.object,
  RecId: PropTypes.number
};

export default EditDirectionForm;
